/**
 * IntentCard — intenção detectada pela IA na aba Conversa.
 *
 * Renderiza o que o backend REALMENTE produz (último `AIConductorTurn` com
 * `intentClassification`): a ação (rótulo pt-BR) + a confiança + quando foi
 * detectada. Lifecycle (suggested/confirmed/refuted), intents secundários,
 * rationale e o botão "Confirmar" do mockup original (r7a/entity-blocks.jsx)
 * são **honest-defer** — não há modelo de confirmação de intenção no backend,
 * então NÃO são fabricados.
 *
 * Invariante: sem intenção detectada → estado honesto, NUNCA o negativo falso
 * "nenhuma intenção detectada" (a IA pode simplesmente não ter classificado
 * ainda, ou estar em H_a).
 */

import { LifecycleBadge } from './LifecycleBadge';

import type { DetectedIntent } from '../../hooks/use-panel-fixtures';

export function IntentCard({ intent }: { intent: DetectedIntent | null }): JSX.Element {
  if (intent === null) {
    return (
      <p className="text-xs text-text-secondary opacity-70 italic">
        A IA ainda não registrou uma intenção nesta conversa.
      </p>
    );
  }

  return (
    <div className="intent-card" data-testid="intent-card">
      <header className="intent-card__head">
        <span aria-hidden>🏷</span>
        <span>Intenção ativa</span>
        <span style={{ marginLeft: 'auto' }}>
          {/* Estado 'detected': a IA classificou; sem fluxo de confirmação no
              backend, é o único estado honesto (badge cinza + confiança). */}
          <LifecycleBadge state="detected" confidence={intent.confidence} />
        </span>
      </header>

      <div className="intent-card__primary">{intent.label}</div>

      <div className="intent-card__footer">
        <span>✨ detectado {intent.detectedAtFull}</span>
      </div>
    </div>
  );
}
